// function ISupSapLog(){
//   return (
//     <h1>SAP REQUEST MONITOR</h1>
//   )

// }

// export default ISupSapLog;

import React, { useEffect, useState } from "react";
import {
  Alert, 
  AlertTitle,
  
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  Grid,
  // TextareaAutosize,  
  
  Paper
  ,
} from "@mui/material";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { checkForRole } from "../../utils/GetAuth";
import {
  Lock,
} from '@mui/icons-material';
import { searchSapLogs } from "../../utils/PostAdmin";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    root: {},
    card: {},
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    checkbox: {
      padding: 0,
    },
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
    modalInput: {
      width: "350px",
    },
    searchField:{
      width:"35%",
    },
    searchCard:{
      display:"flex",
    }
  })
);



/**
 * 
 */
 export function SapRequestMonitor(params:{clientId:string, salesOrg:string}) {
  const classes = useStyles();
  
  const clientId = params.clientId;
  const salesOrg = params.salesOrg;

  const [searchText, setSearchText] = useState("");
  const [showLog, setShowLog] = useState([]);

  function handleSearch(){
    if (searchText.length>0) {
      searchSapLogs(salesOrg, searchText).then((resp) => {
        if (resp) {
          setShowLog(resp?.data);
        }
      })
    }else{
      setShowLog([])
    }
    
  }
  

  return (
    <Grid container spacing={2} className={classes.primary}> 
      <Grid item xs={12} xl={12}>
        <Card className={classes.card}>
              <CardContent className={classes.searchCard}>
                    <TextField className={classes.searchField} onChange={(e)=>{setSearchText(e.target.value)}} id="standard-basic" label="Search" variant="standard" placeholder="100_org_plant_route_yyyy-mm-dd" />
                    <Button variant="contained" onClick={handleSearch}>Search</Button>
              </CardContent>
        </Card>
        
      </Grid>
      {showLog.length>0?
        <Grid item md={12} lg={12}>
        <Card className={classes.card}>
            <CardContent className={classes.searchCard}>
                  <ol>
                    {showLog.map((log:any,id)=>{
                      return <li key={id}>{log?.query_params1}</li>
                    })}
                  </ol>
            </CardContent>
        </Card>
      </Grid> :<></>
      }
      
    </Grid>
    
    )
}

export default function ISupSapLog() {
  const classes = useStyles();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const enabled = checkForRole(clientId,salesOrg,'cona_internal_dev');
  const [doneLoading, setDoneLoading] = React.useState<boolean>();

  const [curTab, setCurTab] = React.useState<number>(0);
  const subtabs = [
    {
      title: "SAP REQUEST MONITOR",
      content: <SapRequestMonitor clientId={clientId} salesOrg={salesOrg} />,
    }
  ];

  useEffect(() => {
    if (doneLoading) return;

    setDoneLoading(true);
  }, [doneLoading,salesOrg]);

  return (
     <div>
       {enabled ? (
        <div className={classes.root}>
          <Typography variant="h4" className={classes.paragraph}>
            CONA Support Tools: Sap Request Monitor 
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            This page allows you to 
            <strong> Fetch the Logs from the SAP</strong> 
          </Typography>
          <Paper className={classes.root}>
              {subtabs[curTab].content}
            </Paper>
        </div>
        ) : (
        <Alert severity="error">
          <AlertTitle><Lock/> Access Error</AlertTitle>   
          You do not currently have access to <strong>CONA Internal Support</strong> activities for the <strong>{salesOrg}</strong> bottler. 
        </Alert>
      )}
     </div>
    )
}
